import clsx from 'clsx';
import React, { useState } from 'react';
import { Pressable, View } from 'react-native';
import { twMerge } from 'tailwind-merge';
import { CheckmarkIcon } from '../Icons/CheckmarkIcon';
import { Typography } from '../Text';

export type CheckboxProps = {
  onChange?: (value: boolean) => void;
  value?: boolean;
  className?: string;
  label?: string;
  error?: string;
  children?: React.ReactNode;
};

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  onChange,
  className,
  children,
  value,
  error,
}) => {
  const [internalValue, setInternalValue] = useState<boolean>(value ?? false);
  const effectiveValue = value != null ? value : internalValue;

  const handleToggle = () => {
    const newValue = !effectiveValue;

    setInternalValue(newValue);
    onChange?.(newValue);
  };

  return (
    <View>
      <Pressable
        className={twMerge(
          'flex flex-row items-center group focus:outline-none focus:border-none',
          className
        )}
        onPress={handleToggle}
      >
        <View
          className={twMerge(
            'w-[24px] h-[24px] rounded-md bg-[#152237] border border-[#2E3B80] group-hover:border-prim-blue group-active:border-2 group-focus:border-2 group-focus:border-prim-blue ',
            clsx({ 'border-2 border-prim-blue': effectiveValue })
          )}
        >
          {effectiveValue && <CheckmarkIcon className="mt-[4px] ml-[2px]" />}
        </View>
        {children || (
          <Typography
            className="mx-2 text-white"
            variant="callToAction"
            size="small"
          >
            {label}
          </Typography>
        )}
      </Pressable>
      {error && (
        <Typography
          variant="body"
          size="small"
          weight="regular"
          className="text-error mt-2 shrink"
        >
          {error}
        </Typography>
      )}
    </View>
  );
};
